// extracted by mini-css-extract-plugin
export default {"carousel_cards":"CarouselHero_carousel_cards__s34EU"};